/* ==========================================================================
   Delecora — shared theme behaviour
   Cart runs on Shopify's AJAX Cart API; the drawer markup is re-rendered
   server-side through the Section Rendering API so money formatting,
   discounts and line properties always match the storefront.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.Delecora || {};
  var routes = CFG.routes || {};
  var strings = CFG.strings || {};

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast');
    if (!t || !msg) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  window.delecoraToast = toast;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || CFG.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');

    function defaultTo(value, def) { return value == null || value === '' ? def : value; }

    function withDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents_ = parts[1] ? decimal + parts[1] : '';
      return dollars + cents_;
    }

    /* Indian grouping (1,23,456) when the format asks for it. */
    function withIndianDelimiters(number, precision) {
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0];
      var last3 = dollars.slice(-3);
      var rest = dollars.slice(0, -3);
      if (rest) last3 = ',' + last3;
      rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      return rest + last3 + (parts[1] ? '.' + parts[1] : '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholderRegex);
    if (!match) return fmt;

    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withIndianDelimiters(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  window.delecoraFormatMoney = formatMoney;

  /* ---------- Overlay / drawers ---------- */
  var overlay = $('#overlay');

  function cartDrawer() { return $('#cartDrawer'); }
  function searchOverlay() { return $('#searchOv'); }

  function syncOverlay() {
    if (!overlay) return;
    var cart = cartDrawer();
    var search = searchOverlay();
    var open = (cart && cart.classList.contains('open')) || (search && search.classList.contains('show'));
    overlay.classList.toggle('show', !!open);
  }

  function openCart() {
    var d = cartDrawer();
    if (!d) return;
    d.classList.add('open');
    syncOverlay();
  }
  function closeCart() {
    var d = cartDrawer();
    if (!d) return;
    d.classList.remove('open');
    syncOverlay();
  }
  window.delecoraOpenCart = openCart;

  function openSearch() {
    var s = searchOverlay();
    if (!s) return;
    s.classList.add('show');
    syncOverlay();
    setTimeout(function () { var i = $('#searchInput'); if (i) i.focus(); }, 100);
  }
  function closeSearch() {
    var s = searchOverlay();
    if (!s) return;
    s.classList.remove('show');
    syncOverlay();
  }

  /* ==================== Cart ====================
     Rewritten to use ONE network round trip instead of two.

     Shopify's Cart AJAX API accepts a `sections` parameter directly in the
     POST body of /cart/add.js and /cart/change.js, and returns the freshly
     rendered section HTML inside the SAME response. The previous version
     fired the mutation, waited for it, and only then fired a second GET to
     fetch the HTML — so every add/remove cost two sequential round trips,
     and any slowness on either one stacked up before the UI moved at all.

     Sections declared inside a JSON template (cart.json's "main-cart") are
     rendered by Shopify with a compound DOM id such as
     "template--1234__main-cart"; only sections included directly through
     {% section 'x' %} (cart-drawer, in theme.liquid) keep the plain name.
     Every id below is therefore resolved from the live DOM rather than
     assumed, both when requesting the section and when injecting it back. */

  function resolveSectionId(shortId) {
    if (document.getElementById('shopify-section-' + shortId)) return shortId;
    var compound = document.querySelector('[id^="shopify-section-"][id$="__' + shortId + '"]');
    return compound ? compound.id.replace('shopify-section-', '') : shortId;
  }

  function sectionsToRender() {
    var ids = [resolveSectionId('cart-drawer')];
    if (document.body.classList.contains('template-cart')) {
      ids.push(resolveSectionId('main-cart'));
    }
    return ids;
  }

  /* Swap a section's markup in place, preserving whether the drawer was open. */
  function applySectionHTML(sectionId, html) {
    var target = document.getElementById('shopify-section-' + sectionId);
    if (!target || !html) return;

    var existing = target.querySelector('#cartDrawer');
    var wasOpen = !!(existing && existing.classList.contains('open'));

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#shopify-section-' + sectionId);
    target.innerHTML = fresh ? fresh.innerHTML : html;

    if (wasOpen) {
      var drawer = target.querySelector('#cartDrawer');
      if (drawer) drawer.classList.add('open');
    }
  }

  /* Paint every section returned alongside a cart mutation. */
  function applyCartResponse(payload) {
    if (payload && payload.sections) {
      Object.keys(payload.sections).forEach(function (id) {
        applySectionHTML(id, payload.sections[id]);
      });
    }
    syncOverlay();
    setCartCount(payload && typeof payload.item_count === 'number' ? payload.item_count : null);
    document.dispatchEvent(new CustomEvent('delecora:cart:updated'));
  }

  /* Fallback path: only used if a mutation response arrives without sections
     (older API behaviour, or an app intercepting the request). */
  function refreshCartSections() {
    var url = new URL(window.location.href);
    var previewThemeId = url.searchParams.get('preview_theme_id');
    url.search = '';
    url.searchParams.set('sections', sectionsToRender().join(','));
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    url.searchParams.set('_', Date.now());

    return fetch(url.toString(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) { applyCartResponse({ sections: data }); })
      .catch(function () {});
  }

  /* item_count comes back on every mutation response, so the badge updates
     without its own extra request. Only falls back to /cart.js when a count
     wasn't supplied (e.g. the fallback refresh path above). */
  function setCartCount(count) {
    var dot = $('#cartDot');
    if (!dot) return;
    if (typeof count === 'number') {
      dot.textContent = count;
      dot.classList.toggle('on', count > 0);
      return;
    }
    fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        dot.textContent = cart.item_count;
        dot.classList.toggle('on', cart.item_count > 0);
      })
      .catch(function () {});
  }
  function updateCartCount() { setCartCount(null); }

  /* Tracks any in-flight mutation so checkout can't navigate mid-update. */
  var cartBusy = null;
  function trackBusy(promise) {
    cartBusy = promise.then(function (v) { cartBusy = null; return v; }, function (v) { cartBusy = null; return v; });
    return cartBusy;
  }

  /* Shared body fields that make Shopify return rendered HTML with the
     mutation result, removing the need for a follow-up fetch. */
  function withSections(body) {
    body.sections = sectionsToRender().join(',');
    body.sections_url = window.location.pathname + window.location.search;
    return body;
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      cache: 'no-store',
      body: JSON.stringify(withSections(body))
    }).then(function (r) {
      return r.json().then(function (b) { return { ok: r.ok, body: b }; });
    });
  }

  function addToCart(variantId, quantity, productTitle) {
    if (!variantId) return Promise.resolve(false);

    return trackBusy(
      postCart(routes.cartAdd, { items: [{ id: Number(variantId), quantity: quantity || 1 }] })
        .then(function (res) {
          if (!res.ok) {
            toast((res.body && (res.body.description || res.body.message)) || 'Could not add to bag');
            return false;
          }

          applyCartResponse(res.body);
          openCart();

          /* No success toast here: the drawer opening already confirms the add,
             and on mobile a full-width drawer left a centered toast with nowhere
             to sit but on top of the checkout button. */

          /* Only if Shopify didn't hand back the markup. */
          if (!res.body.sections) return refreshCartSections().then(function () { return true; });
          return true;
        })
        .catch(function () { toast('Could not add to bag'); return false; })
    );
  }
  window.delecoraAddToCart = addToCart;

  function changeLine(line, quantity) {
    return trackBusy(
      postCart(routes.cartChange, { line: Number(line), quantity: quantity })
        .then(function (res) {
          if (!res.ok) return refreshCartSections();
          applyCartResponse(res.body);
          if (!res.body.sections) return refreshCartSections();
        })
        .catch(function () { return refreshCartSections(); })
    );
  }

  /* ---------- Quick-add size sheet (shared, slides up from the bottom) ---------- */
  var sizeSheet = $('#sizeSheet');
  var sizeSheetBackdrop = $('#sizeSheetBackdrop');
  var sizeSheetOptions = $('#sizeSheetOptions');
  var sizeSheetTitle = $('#sizeSheetTitle');
  var sizeSheetCloseBtn = $('#sizeSheetClose');
  var sizeSheetPendingTitle = '';

  function openSizeSheet(sizesJson, productName) {
    if (!sizeSheet || !sizeSheetOptions) return;
    var sizes;
    try { sizes = JSON.parse(sizesJson || '[]'); } catch (err) { sizes = []; }

    sizeSheetPendingTitle = productName || '';
    if (sizeSheetTitle) sizeSheetTitle.textContent = 'Select Size';

    sizeSheetOptions.innerHTML = '';
    sizes.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'quick-size-btn';
      b.textContent = s.label;
      b.setAttribute('data-add-variant', s.id);
      if (!s.available) b.disabled = true;
      sizeSheetOptions.appendChild(b);
    });

    sizeSheet.hidden = false;
    sizeSheetBackdrop.hidden = false;
    sizeSheet.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      sizeSheet.classList.add('open');
      sizeSheetBackdrop.classList.add('open');
    });
  }

  function closeSizeSheet() {
    if (!sizeSheet) return;
    sizeSheet.classList.remove('open');
    sizeSheetBackdrop.classList.remove('open');
    sizeSheet.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () {
      if (!sizeSheet.classList.contains('open')) {
        sizeSheet.hidden = true;
        sizeSheetBackdrop.hidden = true;
      }
    }, 350);
  }

  if (sizeSheetCloseBtn) sizeSheetCloseBtn.addEventListener('click', closeSizeSheet);
  if (sizeSheetBackdrop) sizeSheetBackdrop.addEventListener('click', closeSizeSheet);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sizeSheet && sizeSheet.classList.contains('open')) closeSizeSheet();
  });

  /* Delegated cart events — survives drawer re-renders. */
  document.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('[data-add-variant]');
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (sizeBtn.disabled) return;
      var inSheet = sizeSheetOptions && sizeSheetOptions.contains(sizeBtn);
      var groupBtns = inSheet
        ? sizeSheetOptions.querySelectorAll('[data-add-variant]')
        : [sizeBtn];
      groupBtns.forEach(function (b) { b.disabled = true; });
      sizeBtn.classList.add('active');
      addToCart(sizeBtn.getAttribute('data-add-variant'), 1, sizeSheetPendingTitle).then(function () {
        groupBtns.forEach(function (b) { b.disabled = false; });
        sizeBtn.classList.remove('active');
        if (inSheet) closeSizeSheet();
      });
      return;
    }

    var addBtn = e.target.closest('[data-add], [data-needs-size]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (addBtn.disabled) return;

      if (addBtn.hasAttribute('data-needs-size')) {
        openSizeSheet(addBtn.getAttribute('data-sizes'), addBtn.getAttribute('data-product-name'));
        return;
      }

      var picker = addBtn.getAttribute('data-variant-picker');
      if (picker) { window.location.href = picker; return; }
      var card = addBtn.closest('.prod-card');
      var title = card ? (card.querySelector('.prod-name') || {}).textContent : '';
      addBtn.disabled = true;
      addToCart(addBtn.getAttribute('data-add'), 1, title && title.trim()).then(function () {
        addBtn.disabled = false;
      });
      return;
    }

    var qtyBtn = e.target.closest('.ci-qty button, .ci-del, .si-qty button');
    if (qtyBtn) {
      e.preventDefault();
      if (qtyBtn.disabled) return;
      var line = qtyBtn.getAttribute('data-line');
      if (!line) return;
      var act = qtyBtn.getAttribute('data-act');
      var row = qtyBtn.closest('.cart-item, .sum-item');
      var qtyLabel = row ? row.querySelector('.ci-qty b, .si-qty b') : null;
      var current = qtyLabel ? parseInt(qtyLabel.textContent, 10) || 1 : 1;
      var next;
      if (act === 'plus') next = current + 1;
      else if (act === 'minus') next = Math.max(0, current - 1);
      else if (act === 'del') next = 0;
      else return;
      /* Optimistic UI — reflect the change instantly instead of waiting on the
         network round trip; refreshCartSections() true's it up once the server
         confirms. Buttons stay disabled meanwhile so a second click can't race
         the in-flight request (the row is replaced wholesale on completion, so
         there's nothing to manually re-enable). */
      if (row) {
        $$('button', row).forEach(function (b) { b.disabled = true; });
        if (next === 0) {
          row.style.transition = 'opacity .15s ease';
          row.style.opacity = '0.35';
        } else if (qtyLabel) {
          qtyLabel.textContent = next;
        }
      }
      changeLine(line, next);
      return;
    }

    if (e.target.closest('[data-close="cart"]')) { e.preventDefault(); closeCart(); return; }
    if (e.target.closest('#cartBtn')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('#searchBtn')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('#searchClose')) { e.preventDefault(); closeSearch(); return; }
  });

  /* Reset an opened size row back to the plain "Add to Bag" button once the
     shopper's mouse leaves the card without picking a size. */
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest ? e.target.closest('.prod-card') : null;
    if (!card) return;
    var toCard = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.prod-card') : null;
    if (toCard === card) return;
    var sizes = card.querySelector('[data-quick-sizes]');
    var resetBtn = card.querySelector('[data-needs-size]');
    if (sizes && !sizes.hidden) {
      sizes.hidden = true;
      if (resetBtn) resetBtn.hidden = false;
    }
  });

  /* Guard against navigating to checkout while a quantity change or add-to-cart
     request for this cart is still in flight — otherwise checkout can load the
     cart's previous state (e.g. quantity 1 shown in the drawer, but the pending
     update to 1 hasn't landed yet, so checkout still shows the old quantity). */
  document.addEventListener('submit', function (e) {
    var btn = e.submitter || (e.target.querySelector && e.target.querySelector('button[name="checkout"]'));
    if (!btn || btn.name !== 'checkout' || !cartBusy) return;
    e.preventDefault();
    var form = e.target;
    var pending = cartBusy;
    btn.disabled = true;
    pending.then(function () { HTMLFormElement.prototype.submit.call(form); });
  });

  if (overlay) {
    overlay.addEventListener('click', function () { closeCart(); closeSearch(); });
  }

  var searchOv = searchOverlay();
  if (searchOv) {
    searchOv.addEventListener('click', function (e) { if (e.target === searchOv) closeSearch(); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeCart(); }
  });

  /* ---------- Predictive search ---------- */
  var searchInput = $('#searchInput');
  if (searchInput) {
    var searchTimer;
    var lastQuery = '';
    searchInput.addEventListener('input', function (e) {
      var q = e.target.value.trim();
      var box = $('#searchRes');
      if (!box) return;
      clearTimeout(searchTimer);
      if (!q) { box.innerHTML = ''; lastQuery = ''; return; }
      if (q === lastQuery) return;
      searchTimer = setTimeout(function () {
        lastQuery = q;
        var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var results = parsed.querySelector('#predictive-results');
            box.innerHTML = results ? results.innerHTML :
              '<p style="color:var(--ink-mute);padding:20px 0">' + (strings.noResults || 'No results') + '</p>';
          })
          .catch(function () {
            box.innerHTML = '<p style="color:var(--ink-mute);padding:20px 0">' + (strings.noResults || 'No results') + '</p>';
          });
      }, 220);
    });
  }

  /* ---------- Wishlist (browser-local, keyed by product handle) ---------- */
  var WISH_KEY = 'delecora_wish';

  function readWish() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function paintWishDot() {
    var dot = $('#wishDot');
    if (!dot) return;
    var n = readWish().length;
    dot.textContent = n;
    dot.classList.toggle('on', n > 0);
  }
  function paintWishHearts(root) {
    var list = readWish();
    $$('[data-wish]', root || document).forEach(function (btn) {
      btn.classList.toggle('active', list.indexOf(btn.getAttribute('data-wish')) !== -1);
    });
  }
  window.delecoraWishlist = {
    read: readWish,
    write: writeWish,
    paintDot: paintWishDot,
    paintHearts: paintWishHearts
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wish');
    var list = readWish();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.push(handle);
      writeWish(list);
      btn.classList.add('active');
      toast(strings.savedToWishlist || 'Saved to wishlist');
    } else {
      list.splice(i, 1);
      writeWish(list);
      btn.classList.remove('active');
      toast(strings.removedFromWishlist || 'Removed from wishlist');
    }
    paintWishDot();
    document.dispatchEvent(new CustomEvent('delecora:wishlist:updated', { detail: { handle: handle } }));
  });

  /* ---------- Mobile drawer (hamburger menu, all pages / all breakpoints) ---------- */
  var mmOpen = $('#mmOpen');
  var mmClose = $('#mmClose');
  var mobileMenu = $('#mobileMenu');
  var drawerBackdrop = $('#drawerBackdrop');

  function openDrawer() {
    mobileMenu.classList.add('open');
    if (drawerBackdrop) drawerBackdrop.classList.add('open');
    if (mmOpen) mmOpen.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    mobileMenu.classList.remove('open');
    if (drawerBackdrop) drawerBackdrop.classList.remove('open');
    if (mmOpen) mmOpen.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }

  if (mmOpen && mobileMenu) {
    mmOpen.addEventListener('click', openDrawer);
  }
  if (mmClose && mobileMenu) {
    mmClose.addEventListener('click', closeDrawer);
  }
  if (drawerBackdrop && mobileMenu) {
    drawerBackdrop.addEventListener('click', closeDrawer);
  }
  if (mobileMenu) {
    $$('#mobileMenu a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeDrawer();
    });
  }

  /* ---------- Scroll chrome ---------- */
  var header = $('#header');
  var topBtn = $('#topBtn');

  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (header) header.classList.toggle('scrolled', y > 8);
    if (topBtn) topBtn.classList.toggle('show', y > 500);
  }, { passive: true });

  if (topBtn) {
    topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Reveal on scroll ---------- */
  function observeReveals(root) {
    var els = $$('.reveal:not(.in)', root || document);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }
  window.delecoraObserveReveals = observeReveals;

  /* ---------- Accordions (shared by product + FAQ) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.acc-btn');
    if (!btn) return;
    var item = btn.closest('.acc-item');
    if (!item) return;
    item.classList.toggle('open');
  });

  /* ---------- Init ---------- */
  function init() {
    paintWishDot();
    paintWishHearts();
    observeReveals();
    var year = $('#year');
    if (year && !year.textContent.trim()) year.textContent = new Date().getFullYear();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function () {
    paintWishDot();
    paintWishHearts();
    observeReveals();
  });
})();
